/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QueryLeaderboardParamsAttributeFilterDTO
 */
export interface QueryLeaderboardParamsAttributeFilterDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryLeaderboardParamsAttributeFilterDTO
     */
    path: string;
}

/**
 * Check if a given object implements the QueryLeaderboardParamsAttributeFilterDTO interface.
 */
export function instanceOfQueryLeaderboardParamsAttributeFilterDTO(value: object): value is QueryLeaderboardParamsAttributeFilterDTO {
    if (!('path' in value) || value['path'] === undefined) return false;
    return true;
}

export function QueryLeaderboardParamsAttributeFilterDTOFromJSON(json: any): QueryLeaderboardParamsAttributeFilterDTO {
    return QueryLeaderboardParamsAttributeFilterDTOFromJSONTyped(json, false);
}

export function QueryLeaderboardParamsAttributeFilterDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryLeaderboardParamsAttributeFilterDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'path': json['path'],
    };
}

export function QueryLeaderboardParamsAttributeFilterDTOToJSON(value?: QueryLeaderboardParamsAttributeFilterDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'path': value['path'],
    };
}

